import Axios from 'axios';

Axios.defaults.baseURL = 'https://api.zero7shirts.com/api';

export const axiosInstance = Axios.create({});
